/**
 * Uma área da mesa única (E201.F1, GUS-47, ADR-0144): a âncora que o índice, o próximo passo e os
 * links antigos com hash alcançam. A margem de rolagem deixa o título visível sob o rodapé fixo.
 */
import type { ReactNode } from 'react';

export interface SecaoDaMesaProps {
  id: string;
  /** Título da área; sem título, a área é a do próprio card que ela embrulha. */
  titulo?: string;
  children: ReactNode;
}

export function SecaoDaMesa({ id, titulo, children }: SecaoDaMesaProps): JSX.Element {
  const tituloId = `${id}-titulo-da-area`;
  return (
    <section
      id={id}
      className="mt-sc-6 scroll-mt-sc-6"
      aria-labelledby={titulo !== undefined ? tituloId : undefined}
      data-testid={`mesa-area-${id}`}
    >
      {titulo !== undefined ? (
        <h2 id={tituloId} className="mb-sc-3 text-body-lg font-semibold text-fg">
          {titulo}
        </h2>
      ) : null}
      {children}
    </section>
  );
}
